/**
 * Gespeicherte Schwachstellen-Statusnamen (Tabelle schwachstellen_status).
 * „Geprüft“ ist nur die Anzeige von „Geprueft“; ungeprüft entspricht „Entwurf“
 * bzw. einem fehlenden Status.
 */
export const SCHWACHSTELLE_STATUS_GEPRUEFT = 'Geprueft';
export const SCHWACHSTELLE_STATUS_ENTWURF = 'Entwurf';
export const SCHWACHSTELLE_STATUS_REVIEW_ERBETEN = 'Review erbeten';
export const SCHWACHSTELLE_STATUS_ABGELEHNT = 'Abgelehnt';

export interface FindingReviewStatus {
  status?: { name?: string | null } | null;
}

/** Nur der gespeicherte Status „Geprueft“ zählt als geprüft. */
export function isSchwachstelleGeprueft(statusName?: string | null): boolean {
  return statusName === SCHWACHSTELLE_STATUS_GEPRUEFT;
}

/** Schwachstellen, die vor dem Report noch geprüft werden sollten. */
export function unreviewedSchwachstellen<T extends FindingReviewStatus>(findings: T[]): T[] {
  return findings.filter((finding) => !isSchwachstelleGeprueft(finding.status?.name));
}
